/* eslint-disable no-param-reassign */
import { enumOptions, enumReverse } from './enum';

const commonPlugin = {
  install(app) {
    app.prototype.$enumOptions = enumOptions;
    app.prototype.$enumReverse = enumReverse;
  },
};

export default commonPlugin;
